import React from 'react';
import {Button} from 'react-bootstrap'
import SettingsTextInputPassword from '../../../components/UserProfil/SettingsPassword/SettingsTextInputPassword';
import SettingsInterfacePassword from '../../../components/UserProfil/SettingsPassword/SettingsInterfacePassword';
/*
    this class regroup the text input for the old password the new one and the confirmation of nex password
    text Input are ine file SettingsTextInputPassword
*/
interface AccountParametersPasswordSettingsProps
{
	state: SettingsInterfacePassword
    handleChange(event: React.FormEvent<HTMLInputElement>, target: string): void
    sbmitNewPassword(): void
}

interface AccountParametersPasswordState {
}

export default class AccountParametersSettings extends React.Component<AccountParametersPasswordSettingsProps, AccountParametersPasswordState> {
	
	constructor(props: AccountParametersPasswordSettingsProps) {
        super(props);
        this.state = {
		};
    }

    render() {
        return (
            <div>
                <div id="Ancien_mot_de_passe" className={"row"}>
                    <SettingsTextInputPassword
						name="Ancien mot de passe"
                        label={"Ancien mot de passe"}
                        value={this.props.state.oldPassword}
                        error={this.props.state.errorOldPassword}
                        handleChange={(e) => this.props.handleChange(e, "oldPassword")}
                    />
                </div>
                <br/>
                <div id="Nouveau_mot_de_passe" className={"row"}>
                    <SettingsTextInputPassword
						name="Nouveau mot de passe"
                        label={"Nouveau mot de passe"}
                        value={this.props.state.newPassword}
                        error={this.props.state.errorNewPassword}
                        handleChange={(e) => this.props.handleChange(e, "newPassword")}
                    />
                </div>
                <br/>
                <div id="Confirmer_le_nouveau_mot_de_passe" className={"row"}>
                    <SettingsTextInputPassword
                        name="Confirmer le nouveau mot de passe"
                        label={"Confirmer le nouveau mot de passe"}
                        value={this.props.state.confirmationPassword}
                        error={this.props.state.errorConfirmationPassword}
                        handleChange={(e) => this.props.handleChange(e, "confirmationPassword")}
                    />
                </div>
                <br/>
                <br/>
                <Button variant="success" onClick={this.props.sbmitNewPassword}>Modifier</Button>
            </div>
        );
    }
}